<p-card data-variant="compact">
  <p-table [value]="claims()" dataKey="id" [rowHover]="true" [loading]="isLoading()">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'ExpenseClaim_Col_Number' | translateWF: 'Number' }}</th>
        <th class="text-right">{{ 'ExpenseClaim_Col_Total' | translateWF: 'Total' }}</th>
        <th>{{ 'Status' | translateWF: 'Status' }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      @let row = getRow(rowData);
      <tr>
        <td>
          <a class="cs-table-link font-mono" (click)="open(row)">{{ row.number }}</a>
        </td>
        <td class="text-right tabular-nums">{{ symbolOf(row.currency) }} {{ row.total | number: '1.2-2' }}</td>
        <td><p-tag [severity]="statusSeverity(row.status)" [value]="statusLabel(row.status)" /></td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3" class="text-center">{{ 'ExpenseClaim_Owner_None' | translateWF: 'No expense claims yet.' }}</td>
      </tr>
    </ng-template>
  </p-table>
</p-card>
